import React from 'react'
// import { useAcceptCookies } from '../utils/useAcceptedCookies'
import { graphql, useStaticQuery } from 'gatsby'
import Cta from './cta'
// import { XMarkIcon } from '@heroicons/react/24/outline'

export default function Alert({ uri }) {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo5OA==" }) {
        header {
          alert {
            displayAlert
            content
            contentDesktop
            link {
              target
              title
              url
            }
          }
        }
      }
    }
  `)
  const { content, link, contentDesktop } = data?.wpOption?.header?.alert
  // const { acceptedCookies, onAcceptCookies } = useAcceptCookies('alert')
  const displayAlert = data?.wpOption?.header?.alert?.displayAlert ? (uri?.includes("hotel") ? false : true) : false

  return (
    <>
      {/* TODO: re-enable cookie and close */}
      {/* {!acceptedCookies && displayAlert ? */}
      {displayAlert ?
        <div className={`relative print:hidden border-t border-t-green-50 bg-light-gray ${link?.url && !link?.title ? "hover:bg-green-50 transition" : ""}`}>
          <div className="container py-4 md:py-5">
            <div className="text-center md:flex md:items-center md:justify-center flex-wrap md:space-x-1">
              <p className="font-bold sm:text-lg  text-purple-900">
                <span className="inline lg:hidden">{content}</span>
                <span className="hidden lg:inline">{contentDesktop || content}</span>
              </p>
              {link ? <div className={`${link?.title ? "" : ""}`}><Cta props={link} className={link?.title ? "text-ruby underline hover:text-ruby-600 font-bold sm:text-lg" : ""} canStretch={true} /></div> : null}
            </div>
            {/* <div className="absolute inset-y-0 right-0 flex items-center z-10">
              <button
                type="button"
                className="flex rounded-md p-2 mr-2 text-white hover:bg-white/5 focus:outline-none focus:ring-2 focus:ring-white"
                onClick={() => onAcceptCookies()}><span className="sr-only">Dismiss</span> <XMarkIcon className="block w-6" strokeWidth={2} aria-hidden="true" />
              </button>

            </div> */}
          </div>
        </div>

        : null}
    </>
  )
}
